'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.congratulations', {
    url: '/congratulations',
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/congratulations/congratulations.html',
        controller: function ($scope, $state, Api, instance, module) {
          $scope.module = module;
          Api.track('module.congratulations', 'view');

          var moduleIndex = _.findIndex(instance.modules, { _id: module._id });
          var nextModule = (moduleIndex >= 0) ? instance.modules[moduleIndex + 1] : false;
          var redirect = function () {
            if (nextModule) {
              $state.go('instance.app.module', { moduleId: nextModule._id });
            } else {
              $state.go('instance.app.dashboard');
            }
          };

          $scope.next = function () {
            Api.track('module.congratulations', 'pass')
              .then(function () {
                if (module.survey) {
                  return $scope.$popup('survey');
                }
              })
              .finally(redirect);
          };
        }
      }
    }
  });

});
